/* ============================================================
   RugKnots Product Page CRO JavaScript
   Deployed: 2026-03-24
   ============================================================ */

(function () {
  'use strict';

  /* ---- Accordion toggle ---- */
  function initAccordions() {
    document.querySelectorAll('.rk-pdp-accordion__trigger').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var body = btn.nextElementSibling;
        var isOpen = body.classList.contains('is-open');
        btn.setAttribute('aria-expanded', isOpen ? 'false' : 'true');
        body.classList.toggle('is-open', !isOpen);
      });
    });
  }

  /* ---- Delivery countdown ---- */
  function initDeliveryCountdown() {
    var el = document.getElementById('rk-pdp-countdown');
    if (!el) return;

    function update() {
      var now = new Date();
      // Cut-off: 5 PM ET (22:00 UTC)
      var cutoff = new Date();
      cutoff.setUTCHours(22, 0, 0, 0);
      if (now.getUTCHours() >= 22) {
        cutoff.setUTCDate(cutoff.getUTCDate() + 1);
      }
      var diff = cutoff - now;
      if (diff <= 0) { diff = 0; }
      var h = Math.floor(diff / 3600000);
      var m = Math.floor((diff % 3600000) / 60000);
      var s = Math.floor((diff % 60000) / 1000);
      el.textContent = h + 'h ' + (m < 10 ? '0' : '') + m + 'm ' + (s < 10 ? '0' : '') + s + 's';
    }
    update();
    setInterval(update, 1000);
  }

  /* ---- Urgency: random viewers & stock ---- */
  function initUrgency() {
    var viewEl = document.getElementById('rk-pdp-viewers');
    var stockEl = document.getElementById('rk-pdp-stock');
    if (!viewEl && !stockEl) return;

    // Seed based on product handle for consistency within a session
    var handle = document.querySelector('[data-product-handle]');
    var seed = handle ? handle.dataset.productHandle.length : 7;
    var viewers = 8 + (seed % 14); // 8–21
    var stock = 3 + (seed % 9);    // 3–11

    if (viewEl) viewEl.textContent = viewers;
    if (stockEl) stockEl.textContent = stock;

    // Slight random drift every 25–45 seconds
    setInterval(function () {
      viewers = Math.max(4, viewers + (Math.random() > 0.5 ? 1 : -1));
      if (viewEl) viewEl.textContent = viewers;
    }, 30000);
  }

  /* ---- Sticky buy bar ---- */
  function initStickyBar() {
    var bar = document.getElementById('rk-pdp-sticky-bar');
    if (!bar) return;

    var buyBox = document.querySelector('.product-information--inner') ||
                 document.querySelector('#ProductInfo-' + (window.__rkSectionId || ''));
    if (!buyBox) {
      // Fallback: use first .product-information div
      buyBox = document.querySelector('.product-information');
    }
    if (!buyBox) return;

    var ticking = false;
    var THRESHOLD = 300; // px from top before bar appears

    function onScroll() {
      if (!ticking) {
        requestAnimationFrame(function () {
          var rect = buyBox.getBoundingClientRect();
          // Show bar when buy box scrolls above viewport
          if (rect.bottom < 0) {
            bar.classList.add('is-visible');
          } else {
            bar.classList.remove('is-visible');
          }
          ticking = false;
        });
        ticking = true;
      }
    }

    window.addEventListener('scroll', onScroll, { passive: true });

    // Wire up sticky ATC button
    var stickyBtn = bar.querySelector('.rk-pdp-sticky__btn');
    if (stickyBtn) {
      stickyBtn.addEventListener('click', function () {
        // Scroll to buy box and click the real ATC button
        buyBox.scrollIntoView({ behavior: 'smooth', block: 'center' });
        setTimeout(function () {
          var atcBtn = document.querySelector('[name="add"]') ||
                       document.querySelector('.product-form__submit') ||
                       document.querySelector('button[type="submit"].btn');
          if (atcBtn) atcBtn.click();
        }, 600);
      });
    }

    // Keep sticky price in sync with variant changes
    var priceEl = bar.querySelector('.rk-pdp-sticky__price-val');
    var compareEl = bar.querySelector('.rk-pdp-sticky__compare');
    if (priceEl) {
      document.addEventListener('variant:change', function (e) {
        if (!e.detail || !e.detail.variant) return;
        var v = e.detail.variant;
        if (v.price) {
          priceEl.textContent = formatMoney(v.price);
        }
        if (compareEl && v.compare_at_price && v.compare_at_price > v.price) {
          compareEl.textContent = formatMoney(v.compare_at_price);
          compareEl.style.display = '';
        } else if (compareEl) {
          compareEl.style.display = 'none';
        }
      });
    }
  }

  /* ---- Money formatter ---- */
  function formatMoney(cents) {
    return '$' + (cents / 100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }

  /* ---- Init on DOM ready ---- */
  function init() {
    initAccordions();
    initDeliveryCountdown();
    initUrgency();
    initStickyBar();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
